// [PATCH konto-iskanje-naziv v1]
// En vir resnice za iskanje kontov po SIFRI ali po NAZIVU. Uporabljajo ga vsa
// vnosna mesta konta: components/KontoSelector.tsx, kopija selektorja v
// pages/DokumentiPage.tsx in KontoVnos v components/KontiranjeEditor.tsx.
// Logike NE podvajaj -- uvozi jo od tu.
//
// ZAVESTNA SPREMEMBA VEDENJA (sprejeto ob uvedbi, 2026-08-21):
// stevilcna veja pred primerjavo odstrani nedigite -- replace(/[^0-9]/g, '').
// V KontoVnos (KontiranjeEditor) je taka maska ze bila na samem vnosu, v OBEH
// selektorjih pa je NI bilo: poizvedba "754.000" tam doslej ni nasla nicesar,
// po tem patchu najde konto 754000. Isto velja za "754 000". Sprejeto kot
// izboljsava, zavedno in dokumentirano.
//
// ZAVESTNA SPREMEMBA VEDENJA #2 -- vnos samih locil ("..." / "--") v KontoVnos
// (components/KontiranjeEditor.tsx): doslej ga je maska [^0-9] pozrla ze med
// tipkanjem, polje je ostalo prazno in blur je poklical onCommit('','') -- konto
// se je POCISTIL. Po tem patchu locila ostanejo vidna, stevk ni, nic se ne zapise
// in polje se povrne na prejsnji konto. Ciscenje konta ostane mogoce z brisanjem
// polja (prazen niz), kar je bila tudi doslej edina namerna pot.
//
// Semantika PRAZNE poizvedbe OSTANE pri klicnem mestu, ker se med mesti
// razlikuje: selektorja pokazeta prvih 50 analiticnih kontov, KontoVnos vrne
// []. Zato tu prazen niz vrne [] in vsako klicno mesto obdrzi svojo else vejo.
//
// Vhodni seznam pride iz GET /sifranti/kontni-plan, ki ima order_by(code)
// (backend/app/api/sifranti.py:111) -- je torej ze urejen po sifri narascajoce.

/** lowercase + NFD + odstranitev diakritike (poizvedba "stroski" najde
 *  naziv, pisan s sumnikom). */
export function normKonto(s: any): string {
  return String(s ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Stevilcna poizvedba = niz NE vsebuje crke.
 *
 * Namenoma NI /^\d+$/: vnos "754.000" ali "754 000" mora ostati stevilcen,
 * sicer pade v besedilno vejo, ne najde nicesar in se konta ne da vpisati.
 * Test tece nad normaliziranim nizom, zato so sumniki ze poklopljeni na ASCII
 * (zapis s sumnikom se poklopi na "stev") in izvorna koda ostane cisti ASCII.
 */
export function jeStevilcna(niz: any): boolean {
  const s = String(niz ?? '').trim();
  if (!s) return false;
  return !/[a-z]/.test(normKonto(s));
}

/** Sifre so nizi. Navaden primerjalnik -- tece ob vsakem pritisku tipke. */
function poSifri(a: any, b: any): number {
  const x = String(a?.code ?? '');
  const y = String(b?.code ?? '');
  return x < y ? -1 : x > y ? 1 : 0;
}

/**
 * Poisce konte po poizvedbi.
 *
 *  - brez crke  -> startsWith na sifri (dosedanje vedenje: "7" pokaze vse
 *                  konte skupine 7). Brez sortiranja in brez prerazvrscanja.
 *  - s crko     -> ujemanje na NAZIVU. Vecbesedna poizvedba zahteva VSE
 *                  zetone, ne nujno zaporedno ("odh donac" najde
 *                  "Odhodki za donacije").
 *
 * Razvrstitev velja SAMO za besedilno vejo: najprej zadetki, kjer se naziv
 * ZACNE s poizvedbo, nato ostali; znotraj obeh po sifri narascajoce.
 *
 * Vhodnega seznama ne mutira (filter/concat delata nad novo tabelo).
 */
export function iskanjeKontov(konti: any[], niz: any, limit: number = 50): any[] {
  const s = String(niz ?? '').trim();
  const seznam = Array.isArray(konti) ? konti : [];
  if (!s) return [];

  if (jeStevilcna(s)) {
    const stevke = s.replace(/[^0-9]/g, '');
    // Robni primer "..." / "--": ni crk in ni stevk. startsWith('') bi vrnil
    // VSE konte; danes tak vnos ne vrne nicesar, zato [].
    if (!stevke) return [];
    return seznam
      .filter((k: any) => String(k?.code ?? '').startsWith(stevke))
      .slice(0, limit);
  }

  const zetoni = normKonto(s).split(/\s+/).filter(Boolean);
  if (!zetoni.length) return [];

  const zacne: any[] = [];
  const vsebuje: any[] = [];
  for (const k of seznam) {
    const naziv = normKonto(k?.name);
    if (!naziv) continue;
    if (!zetoni.every((z: string) => naziv.includes(z))) continue;
    if (naziv.startsWith(zetoni[0])) zacne.push(k);
    else vsebuje.push(k);
  }
  // Vhod je ze urejen po sifri, zato je to varovalka za neurejen seznam,
  // ne prerazvrstitev (sort nad ze urejenim poljem je linearen).
  zacne.sort(poSifri);
  vsebuje.sort(poSifri);
  return zacne.concat(vsebuje).slice(0, limit);
}
